import { combineReducers } from 'redux-immutable'
import { connectRouter } from 'connected-react-router/immutable'
import { reducer as chartReducer } from 'gnos-charts'
import { reducer as tooltipReducer, CONSTANTS } from 'gnos-tooltip'
import { reducer as contextMenuReducer } from 'gnos-context-menu'
import { reducer as tablesReducer } from 'gnos-tables'
import { reducer as scrollbarsReducer } from 'gnos-scrollbar'
import { reducer as formReducer } from 'redux-form/immutable'
import { reducer as toastrReducer } from 'react-redux-toastr'
import { ignoreActions, filterActions } from 'redux-ignore'

import authorizationReducer from '../services/authorization/reducer'
import translateReducer from '../services/translations/reducer'
import scenesReducer from '../scenes/reducers'
import appStateReducer from '../services/appState/reducer'
import dialogReducer from '../services/dialog/reducer'
import virtualListReducer from '../components/VirtualizedList/reducer'
import bannersReducer from '../components/Banners/reducers'
import tabsReducer from '../components/Tabs/reducer'
import financeTableReducer from '../components/FinanceTable/reducer'

const tooltipRegex = new RegExp(
    `^(${CONSTANTS.SHOW_TOOLTIP('')}.+)|(${CONSTANTS.HIDE_TOOLTIP('')}.+)|(${CONSTANTS.SET_TOOLTIP_VALUE})$`
)

const rootReducer = (history) =>
    combineReducers({
        appState: appStateReducer,
        authorization: authorizationReducer,
        charts: chartReducer,
        financeTable: financeTableReducer,
        tables: tablesReducer,
        form: formReducer,
        translate: translateReducer,
        tooltip: filterActions(tooltipReducer, (action) => tooltipRegex.test(action.type)),
        contextMenu: contextMenuReducer,
        dialog: dialogReducer,
        ui: ignoreActions(scenesReducer, (action) => tooltipRegex.test(action.type)),
        virtualList: virtualListReducer,
        banner: bannersReducer,
        toastr: toastrReducer,
        tabs: tabsReducer,
        scrollbar: scrollbarsReducer,
        router: connectRouter(history),
    })

export default rootReducer
